
import Navbar from "./Components/Navbar"
import MainRoutes from "./Router/MainRoutes"
import React from "react";



const App = () => {
  return (
    <div className="App">
      <Navbar/>
      <MainRoutes />
   </div>

  );
};
export default App;
